import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const FullScreenIcon = ({ color = '#fff', size = 15, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 298.667 298.667"
    fill={color}
    width={size}
    height={size}
    {...props}
  >
    <path d="M42.667 192H0v106.667h106.667V256h-64zM0 106.667h42.667v-64h64V0H0zM192 0v42.667h64v64h42.667V0zM256 256h-64v42.667h106.667V192H256z" />
  </svg>
);

FullScreenIcon.propTypes = propTypes;

export default FullScreenIcon;
